// @flow

import React, {Fragment} from 'react';
import type {EventButtonType} from 'src/types';
import {StyledSeparator, SubmenuButton} from './SubmenuButton';

const colorButtons: Array<EventButtonType> = [
  {
    title: 'Red',
    type: 'button',
    icon: '',
    style: {background: 'red'},
    eventType: {
      source: 'colorPalette',
      type: 'red',
    },
  },
  {
    title: 'Blue',
    type: 'button',
    icon: '',
    style: {background: 'blue'},
    eventType: {
      source: 'colorPalette',
      type: 'blue',
    },
  },
  {
    title: 'Green',
    type: 'button',
    icon: '',
    style: {background: 'green'},
    eventType: {
      source: 'colorPalette',
      type: 'green',
    },
  },
  {
    title: 'White',
    type: 'button',
    icon: '',
    style: {background: 'white'},
    eventType: {
      source: 'colorPalette',
      type: 'white',
    },
  },
  {
    title: 'Black',
    type: 'button',
    icon: '',
    style: {background: '#222222'},
    eventType: {
      source: 'colorPalette',
      type: '#222222',
    },
  },
];

type ColorPaletteProps = {
  handleEventClick: (any) => void,
};

type ColorPaletteState = {
  color: string,
};

export class ColorPalette extends React.PureComponent<
  ColorPaletteProps,
  ColorPaletteState
> {
  state = {
    color: 'red',
  };

  render() {
    return (
      <Fragment>
        <StyledSeparator />
        {colorButtons.map((eventButton: EventButtonType) => (
          <SubmenuButton
            key={'colorPalette-' + eventButton.title}
            title={eventButton.title}
            icon={eventButton.icon}
            active={eventButton.eventType.type === this.state.color}
            onClick={() => {
              this.setState({color: eventButton.eventType.type});
              this.props.handleEventClick(eventButton.eventType);
            }}
            style={eventButton.style}
          />
        ))}
        <StyledSeparator />
      </Fragment>
    );
  }
}
